export default "__VITE_ASSET__DIwW1SDe__"